import { render } from "./BlogDetailsRightSidebarPage.vue?vue&type=template&id=3073d813"
import script from "./BlogDetailsRightSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsRightSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__